/**
 * Single source of truth for the reference-section header shared by every
 * Config panel.
 *
 * Two components render this section: the shared `ConfigTabContent` (image,
 * character, location, object, storyboard) and the bespoke
 * `VideoReferencePicker` (video). They used to hold two separate i18n keys,
 * which silently drifted to "References" vs "Reference" — Workplace post
 * 1609245954166035. Both now resolve the key from here, so the panels cannot
 * disagree again.
 *
 * The key lives under `configTabContent.*` because that is where the surviving
 * string already was; borrowing another component's key prefix is the norm in
 * this tree (`VideoReferencePicker` also reads `designerNodeShell.*`,
 * `referenceSelector.*`, `imageHistoryPopover.*` and `imageGeneratorNode.*`).
 */
/**
 * i18n key (namespace `canvas`) for the "References" section header.
 *
 * Deliberately a constant and not an inline string in each component: the
 * constant is what makes the shared ownership greppable, so the next person to
 * split a panel out reuses the key instead of minting a second one.
 *
 * No NAD logging lives here. This module introduces no code path, no branch and
 * no state — a render-time log on a label would be pure noise, and an earlier
 * attempt at one also destabilised the demo run. The regression guard is the
 * component test (`__tests__/referenceSectionLabelParity.test.tsx`), which
 * compares what both panels actually render.
 */
export const REFERENCE_SECTION_LABEL_KEY = 'configTabContent.references'
